// Keep in sync with /config/brand.js
export const BRAND = {
  name:          "PromoMerge",
  tagline:       "Stop quoting from a catalog. Start quoting from live inventory.",
  domain:        "promomerge.com",
  supportEmail:  "contact@promomerge.com",
  colors: {
    primary:     "#10B981",
    primaryDark: "#059669",
    dark:        "#0F172A",
  },
  // Entry-tier price, shown ONLY on the signed-out landing page as a
  // "starting at" figure. It is NOT any given distributor's actual price —
  // plans are Starter/Growth/Enterprise and a real account's price comes from
  // /api/billing/status. Named startingAt (not monthly) so it can't be
  // mistaken for "what this customer pays" again; it previously leaked into
  // the sidebar and the Settings billing tab, showing $49 to everyone.
  pricing: { startingAt: 59 },
};
